import Customers from '@/services/Rest/Customers';
import { check } from '@/services/RouteGuards/SuperAdmin';

export default {
	state: {
		customers: [],
		customersTotal: {
			current_page: 0,
			last_page: 2
		},
		archivedCustomers: [],
		archivedTotal: {
			current_page: 0,
			last_page: 2
		},
		deletedCustomers: [],
		deletedCustomersTotal: {
			current_page: 0,
			last_page: 2
		},
		agentCustomers: [],
		agentCustomersTotal: {
			current_page: 0,
			last_page: 2
		},
		agentArchivedCustomers: {},
		agentArchivedTotal: {
			current_page: 0,
			last_page: 2
		},
		matches: {},
		leadsPagination: {},
		leadsCount: {},
		stagesPagination: {},
		filtersCustomer: [],
		data: {},
		propertiesForMatching: {
			next: '',
			current_page: '',
			properties: []
		},
		propertiesForMatchingPopupMatchCustomer: {
			next: '',
			current_page: '',
			last_page: '',
			properties: []
		},
		totals: {
			total_active: '',
			total_deleted: '',
			total_archived: ''
		},
		customerInfo: {},
		leadDashboardCustomers: {},
		leadDashboardProperties: {},
		leadDashboardCounters: {
			customersCount: '',
			propertiesCount: ''
		},
		initital: true,
		tables: {},
		tableCount: 0,
		customPropertiesChangeStage: [],
		currentSelected: { name: '', color: '', id: '' },
		isAllSelected: false,
		countLeadProperty: 0,
		totalSelectedInStage: {
			component: null,
			total: 0
		}
	},
	actions: {
		setLeadsPaginationAction({ commit }, data) {
			commit('setLeadsPagination', data);
		},
		async leadDashboardCustomerStages({ commit }, data) {
			const res = await Customers.leadDashboardCustomerStages(data);
			commit('setStagesLeadDashboardCustomer', { res: res.data, data });
			commit('setMatchesPaginationCustomer', { data: res.data, paginationInfo: data });
		},
		async leadDashboardPropertyStages({ commit }, data) {
			const res = await Customers.leadDashboardPropertyStages(data);
			commit('setStagesLeadDashboardProperty', { res: res.data, data });
			commit('setMatchesPaginationCustomer', { data: res.data, paginationInfo: data });
		},
		actionIsAllSelected({ commit }, data) {
			commit('updateIsAllSelected', data);
		},
		setCurrentSelected({ commit }, data) {
			commit('mutationResetCustomPropertiesChangeStage');
			commit('setMutationCurrentSelected', data);
		},
		setCustomPropertiesChangeStage({ commit }, data) {
			commit('addCustomPropertiesChangeStage', data);
		},
		removeCustomPropertiesChangeStage({ commit }, data) {
			commit('mutationRemoveCustomPropertiesChangeStage', data);
		},
		resetCustomPropertiesChangeStage({ commit }) {
			commit('mutationResetCustomPropertiesChangeStage');
		},
		// Init fetch
		fetchCustomers({ commit, dispatch }, data) {
			if (data.isFilter) commit('resetTotals');
			// Check if is admin or agent
			if (check()) {
				return Customers.getCustomers(data).then(response => {
					commit('setCustomers', { data: response.data.customers, isFilter: data.isFilter });
					commit('setCustomersTotal', response.data);
					if (data.isFilter) commit('setTotals', response.data);

					return Promise.resolve(response);
				});
			} else {
				return Customers.getAgentCustomers(data).then(response => {
					commit('setAgentCustomers', { data: response.data.customers, isFilter: data.isFilter });
					commit('setAgentCustomersTotal', response.data);
					if (data.isFilter) commit('setTotals', response.data);

					return Promise.resolve(response);
				});
			}
		},
		fetchArchivedCustomers({ commit, dispatch }, data) {
			if (data.isFilter) commit('resetTotals');
			// Check if is admin or agent
			if (check()) {
				return Customers.getArchivedCustomers(data).then(response => {
					commit('setArchivedCustomers', { data: response.data.customers, isFilter: data.isFilter });
					commit('setArchivedCustomersTotal', response.data);
					if (data.isFilter) commit('setTotals', response.data);

					return Promise.resolve(response);
				});
			} else {
				return Customers.getAgentArchivedCustomers(data).then(response => {
					commit('setAgentArchivedCustomers', { data: response.data.customers, isFilter: data.isFilter });
					commit('setAgentArchivedCustomersTotal', response.data);
					if (data.isFilter) commit('setTotals', response.data);

					return Promise.resolve(response);
				});
			}
		},
		fetchDeletedCustomers({ commit, dispatch }, data) {
			if (data.isFilter) commit('resetTotals');
			return Customers.getDeletedCustomers(data).then(response => {
				commit('setDeletedCustomers', { data: response.data.customers, isFilter: data.isFilter });
				commit('setDeletedCustomersTotal', response.data);
				if (data.isFilter) commit('setTotals', response.data);

				return Promise.resolve(response);
			});
		},
		fetchCustomer({ commit, dispatch }, id) {
			if (check()) {
				return Customers.getCustomer(id);
			} else {
				return Customers.getAgentCustomer(id);
			}
		},
		updateCustomer({ commit, dispatch }, customer) {
			if (check()) {
				return Customers.updateCustomer(customer);
			} else {
				return Customers.updateAgentCustomer(customer);
			}
		},
		// Soft delete
		softDeleteCustomer({ commit, dispatch }, data) {
			if (check()) {
				return Customers.softDeleteCustomer(data);
			} else {
				return Customers.softDeleteAgentCustomer(data);
			}
		},
		// Perma delete (only for Super admin)
		deleteCustomer({ commit, dispatch }, data) {
			return Customers.deleteCustomer(data);
		},
		archiveCustomer({ commit, dispatch }, data) {
			if (check()) {
				return Customers.archiveCustomer(data);
			} else {
				return Customers.agentArchiveCustomer(data);
			}
		},
		restoreCustomer({ commit, dispatch }, data) {
			return Customers.restoreCustomer(data);
		},
		// Get lead dashboard Customers
		leadDashboardCustomer({ commit, state }, dataObj) {
			return Customers.leadDashboardCustomer(dataObj).then(response => {
				const result = response.data.matches ? response.data.matches : {};

				commit('leadsCountProperty', response.data.total);
				commit('leadsCount', response.data.stages);
				commit('setLeadDashboardCustomer', { result: result, page: response.data.current_page });
				commit('setLeadDashboardCustomersCount', this.state.tableCount);
				commit('setLeadsPaginationCustomer', { data: response.data, paginationInfo: dataObj });
				return Promise.resolve(response);
			});
		},
		// Get lead dashboard Properties
		leadDashboardProperties({ commit, dispatch }, dataObj) {
			return Customers.leadDashboardProperties(dataObj).then(response => {
				const result = response.data.matches ? response.data.matches : {};
				commit('leadsCountProperty', response.data.total);
				commit('setLeadDashboardProperties', { result: result, page: response.data.current_page });
				commit('leadsCount', response.data.stages);
				commit('setLeadsPaginationCustomer', { data: response.data, paginationInfo: dataObj });

				return Promise.resolve(response);
			});
		},
		async matchingCustomersByStage({ commit, dispatch }, data) {
			const res = await Customers.matchingCustomersByStage(data);
			commit('setMatchesPagination', { data: res.data, paginationInfo: data });
		},
		// Get matches for customer
		async matchingCustomers({ commit, dispatch, state }, data) {
			const res = await Customers.matchingCustomers(data);
			commit('setLeadsPagination', { data: res.data, paginationInfo: data });
			commit('leadsCount', res.data.count_stage);
			commit('leadsCountProperty', res.data.total);
			commit('setCustomerInfo', res.data.customer_data);

			if (state.initital) {
				const newFilters = res.data.filters.map(el => {
					el.labels.map(el => {
						el.show = true;
						return el;
					});
					return el;
				});
				if (res.data.filters && res.data.filters.length > 0) {
					commit('setFilters', newFilters);
				}
			} else {
				if (res.data.filters && res.data.filters.length > 0) {
					commit('setFilters', res.data.filters);
				}
			}
			commit('resetInititalCustomer', false);
			commit('setMatches', { data: res.data.matches, paginationInfo: data });
			commit('setDataCustomers', res.data);
		},
		// Get sorted leads for customer
		async sortCustomersLeads({ commit, dispatch }, data) {
			const res = await Customers.matchingCustomers(data);
			commit('setMatches', res.data.matches);
		},

		async assignCustomerToStageNew({ commit, state }, data) {
			let res;
			if (data.req[0].stageRow === 'Lead') {
				const stagesArr = state.matches.lead;
				if (!state.isAllSelected) { // ex
					res = await Customers.assignPropertyToStage({ data: data.req, notIn: [], all: false, filter: data.filter, id: data.id });
				} else { // all
					const ids = data.req.map(item => item.property_id);
					const notIn = stagesArr.filter(item => !ids.includes(item.id)).map(item => item.id);
					res = await Customers.assignPropertyToStage({ data: data.req, notIn, all: true, filter: data.filter, id: data.id });
				}
				if (res.data.count_lead) {
					state.countLeadProperty = state.countLeadProperty - res.data.count_lead;
				}

				const obj = {
					id: data.id,
					order: data.order,
					order_by: data.order_by,
					page: 1,
					filter: data.filter
				};
				const ress = await Customers.matchingCustomers(obj);
				commit('setLeadsPagination', { data: ress.data, paginationInfo: data });
				commit('leadsCount', ress.data.count_stage);
				commit('leadsCountProperty', ress.data.total);
				commit('setCustomerInfo', ress.data.customer_data);
				commit('setMatches', { data: ress.data.matches, paginationInfo: data });
				commit('setDataCustomers', ress.data);
			} else {
				const stagesArr = state.matches.stages[`st_${data.req[0].stageRow.replaceAll(' ', '_')}`];
				if (!state.isAllSelected) { // ex
					res = await Customers.assignPropertyToStage({ data: data.req, notIn: [], all: false });
				} else { // all
					const ids = data.req.map(item => item.property_id);
					const notIn = stagesArr.filter(item => !ids.includes(item.id)).map(item => item.id);
					res = await Customers.assignPropertyToStage({ data: data.req, notIn, all: true });
				}
				if (res.data.count_lead && data.req[0].stage_name === 'Lead') {
					state.countLeadProperty = state.countLeadProperty + res.data.count_lead;
				}

				if (data.req[0].stage_name === 'Lead') {
					const obj = {
						id: data.id,
						order: data.order,
						order_by: data.order_by,
						page: 1,
						filter: data.filter
					};
					const ress = await Customers.matchingCustomers(obj);
					commit('setLeadsPagination', { data: ress.data, paginationInfo: data });
					commit('leadsCount', ress.data.count_stage);
					commit('leadsCountProperty', ress.data.total);
					commit('setCustomerInfo', ress.data.customer_data);
					commit('setMatches', { data: ress.data.matches, paginationInfo: data });
					commit('setDataCustomers', ress.data);
				}
			}

			commit('changeIfAll', res.data.count_stage);
			commit('updateIsAllSelected', false);
			commit('resetAllStagesCustomer');
			return Promise.resolve(data);
		},
		resetCustomerSelectAll({ commit }) {
			commit('updateIsAllSelected', false);
		},
		//	Assign property to stage for customer
		async assignPropertyToStage({ commit, dispatch }, data) {
			const res = await Customers.assignPropertyToStage(data);
			dispatch('mutationMatches', res);
		},
		// Set changes of stages
		mutationMatches({ commit, state }, data) {
			const newData = JSON.parse(JSON.stringify(state.matches));
			const newStages = data.data.matches.stages;
			for (const key in newStages) {
				newData.stages[key] = newStages[key];
			}

			newData.lead = data.data.matches.lead;
			commit('setMatches', newData);
		},
		getCustomerAssigned({ commit, dispatch }, data) {
			return Customers.getCustomerAssigned(data).then(response => {
				commit('getCustomerAssigned', response.data);

				return Promise.resolve(response);
			});
		},
		// Set changes of filters
		async mutationFiltersCustomers({ commit, state }, data) {
			const res = await Customers.matchingCustomers(data);
			commit('setLeadsPagination', { data: res.data, paginationInfo: data });
			commit('setDataCustomers', res.data);
			commit('leadsCount', res.data.count_stage);
			commit('leadsCountProperty', res.data.total);
			commit('setMatches', { data: res.data.matches, paginationInfo: data });
			commit('setCustomerInfo', res.data.customer_data);
		},
		togglePillsCustomers({ commit, state }, data) {
			commit('setNewFiltersCustomer', data);
		},
		enablePillsCustomers({ commit, state }, data) {
			commit('enabledFiltersCustomer', data);
		},
		// Get properties for matching with current Customer
		propertiesForMatching({ commit, dispatch }, filter) {
			return Customers.getPropertiesForMatching(filter).then(response => {
				commit('setPropertiesForMatching', response.data);
				return Promise.resolve(response);
			});
		},
		propertiesForMatchingPopupMatchCustomer({ commit, dispatch }, filter) {
			return Customers.getPropertiesForMatching(filter).then(response => {
				commit('setPropertiesForMatchingPopupMatchCustomer', { scroll: filter.scroll, next: response.data.next, current_page: response.data.current_page, properties: response.data.properties, last_page: response.data.last_page });
				return Promise.resolve(response);
			});
		},
		// Update after send email
		async emailUpdateCustomers({ commit, dispatch }, data) {
			const res = await Customers.matchingCustomers(data.payload);
			commit('leadsCount', res.data.count_stage);
			commit('emailUpdateCustomerByCustomerId', data);
		},
		actionTotalSelectedInStage({ commit, dispatch }, data) {
			commit('setTotalSelectedInStage', data);
		},
		updateTotalSelectedInStage({ commit, state }, data) {
			const obj = { ...state.totalSelectedInStage };
			const total = data ? obj.total + 1 : obj.total - 1;
			obj.total = total;
			commit('setTotalSelectedInStage', obj);
		},
		resetInititalCustomer({ commit }, data) {
			commit('resetInititalCustomer', data);
		}
	},
	mutations: {
		emailUpdateCustomerByCustomerId(state, data) {
			const customerIds = data.obj.property_id;
			const index = state.matches.lead.findIndex(item => item.id === customerIds);
			state.matches.lead.splice(index, 1);
			state.countLeadProperty = state.countLeadProperty - 1;
		},
		resetInititalCustomer(state, data) {
			state.initital = data;
		},
		resetAllStagesCustomer(state) {
			state.matches.stages = {};
		},
		setTotalSelectedInStage(state, data) {
			state.totalSelectedInStage = data;
		},
		changeIfAll(state, data) {
			const index = data.findIndex(ele => ele.stage_id === 1);
			if (index !== -1) {
				data.splice(index, 1);
			} 
			state.leadsCount = data;
		},
		leadsCountProperty(state, data) {
			state.countLeadProperty = data;
		},
		updateIsAllSelected(state, data) {
			state.isAllSelected = data;
		},
		leadsCount(state, data) {
			const index = data.findIndex(ele => ele.stage_id === 1);
			if (index !== -1) {
				data.splice(index, 1);
			} 
			state.leadsCount = data;
		},
		setLeadsPagination(state, obj) {
			state.leadsPagination = {
				current_page: obj.data.current_page,
				last_page: obj.data.last_page,
				sort_by: obj.paginationInfo.order_by,
				order: obj.paginationInfo.order
			};
		},
		setLeadsPaginationCustomer(state, obj) {
			state.leadsPagination = {
				current_page: obj.data.current_page,
				last_page: obj.data.last_page,
				sort_by: obj.paginationInfo.order_by,
				order: obj.paginationInfo.order
			};
		},
		setMatchesPaginationCustomer(state, obj) {
			state.stagesPagination[obj.paginationInfo.stageName] = {
				current_page: obj.data.current_page,
				last_page: obj.data.last_page,
				sort_by: obj.paginationInfo.order_by,
				order: obj.paginationInfo.order
			};
		},
		setMatchesPagination(state, obj) {
			const matches = obj.data.matches;
			for (const key in matches) {
				if (obj.paginationInfo.page === 1) {
					state.matches.stages[key] = matches[key];
				} else {
					state.matches.stages[key] = [...state.matches.stages[key], ...matches[key]];
				}
				state.stagesPagination[key] = {
					current_page: obj.data.current_page,
					last_page: obj.data.last_page,
					sort_by: obj.paginationInfo.order_by,
					order: obj.paginationInfo.order
				};
			}
		},
		setCustomersTotal(state, data) {
			state.customersTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setAgentCustomersTotal(state, data) {
			state.agentCustomersTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setArchivedCustomersTotal(state, data) {
			state.archivedTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setAgentArchivedCustomersTotal(state, data) {
			state.agentArchivedTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setDeletedCustomersTotal(state, data) {
			state.deletedCustomersTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setMutationCurrentSelected(state, data) {
			state.currentSelected = data;
		},
		addCustomPropertiesChangeStage(state, data) {
			state.customPropertiesChangeStage.push(data);
		},
		mutationRemoveCustomPropertiesChangeStage(state, data) {
			const index = state.customPropertiesChangeStage.findIndex(item => item.property_id === data.property_id);
			state.customPropertiesChangeStage.splice(index, 1);
		},
		mutationResetCustomPropertiesChangeStage(state) {
			state.customPropertiesChangeStage = [];
		},
		setCustomers(state, obj) {
			state.customers = obj.isFilter ? obj.data : [...state.customers, ...obj.data];
		},
		setArchivedCustomers(state, obj) {
			state.archivedCustomers = obj.isFilter ? obj.data : [...state.archivedCustomers, ...obj.data];
		},
		setDeletedCustomers(state, obj) {
			state.deletedCustomers = obj.isFilter ? obj.data : [...state.deletedCustomers, ...obj.data];
		},
		setAgentCustomers(state, obj) {
			state.agentCustomers = obj.isFilter ? obj.data : [...state.agentCustomers, ...obj.data];
		},
		setAgentArchivedCustomers(state, obj) {
			state.agentArchivedCustomers = obj.isFilter ? obj.data : [...state.agentArchivedCustomers, ...obj.data];
		},
		setTotals(state, data) {
			state.totals.total_active = data.total_active;
			state.totals.total_deleted = data.total_deleted;
			state.totals.total_archived = data.total_archived;
		},
		resetTotals(state) {
			state.totals = {
				total_active: '',
				total_deleted: '',
				total_archived: ''
			};
		},
		setLeadDashboardCustomer(state, data) {
			(state.leadDashboardCustomers.st_Lead && data.page !== 1)
				? state.leadDashboardCustomers.st_Lead = [...state.leadDashboardCustomers.st_Lead, ...data.result.st_Lead]
				: state.leadDashboardCustomers = data.result;
		},
		setLeadDashboardProperties(state, data) {
			if (state.leadDashboardProperties.st_Lead && data.page !== 1) {
				state.leadDashboardProperties.st_Lead = [...state.leadDashboardProperties.st_Lead, ...data.result.st_Lead];
			} else {
				state.leadDashboardProperties = data.result;
			}
		},
		setLeadDashboardPropertiesCount(state, data) {
			state.leadDashboardCounters.propertiesCount += data;
		},
		setLeadDashboardCustomersCount(state, data) {
			state.leadDashboardCounters.customersCount += data;
		},
		// setLeadDashboardPropertiesCount(state, data) {
		// 	state.leadDashboardCounters.propertiesCount = data;
		// },
		updateMatchesCustomers(state, data) {
			state.matches = data.data.matches;
			state.propertiesForMatching = {
				next: data.data.properties_for_matching.next,
				current_page: data.data.properties_for_matching.current_page,
				customers: data.data.properties_for_matching.properties
			};
		},
		setDataCustomers(state, data) {
			state.data = data;
		},
		setMatches(state, obj) {
			if (obj.paginationInfo.page === 1) {
				state.matches = obj.data;
			} else {
				state.matches.lead = [...state.matches.lead, ...obj.data.lead];
			}
		},
		setStagesLeadDashboardCustomer(state, obj) {
			if (state.leadDashboardCustomers[obj.data.stageName] && obj.res.current_page !== 1) {
				state.leadDashboardCustomers[obj.data.stageName] = [...state.leadDashboardCustomers[obj.data.stageName], ...obj.res.data];
			} else {
				state.leadDashboardCustomers[obj.data.stageName] = obj.res.data;
			}
		},
		setStagesLeadDashboardProperty(state, obj) {
			if (state.leadDashboardProperties[obj.data.stageName] && obj.res.current_page !== 1) {
				state.leadDashboardProperties[obj.data.stageName] = [...state.leadDashboardProperties[obj.data.stageName], ...obj.res.data];
			} else {
				state.leadDashboardProperties[obj.data.stageName] = obj.res.data;
			}
		},
		setFilters(state, data) {
			state.filtersCustomer = data;
		},
		setNewFiltersCustomer(state, data) {
			state.filtersCustomer.forEach(el => {
				if (el.key === data.key) {
					el.labels.forEach(el => {
						if (data.flag) {
							el.show = false;
						} else {
							if (el.value === data.item.value) {
								el.show = !el.show;
							}
						}
					});
				}
			});
		},
		enabledFiltersCustomer(state, data) {
			state.filtersCustomer.forEach(el => {
				if (el.key === data.key) {
					el.labels.forEach(el => {
						el.show = !data.status;
					});
				}
			});
		},
		setPropertiesForMatching(state, data) {
			state.propertiesForMatching = {
				next: data.next,
				current_page: data.current_page,
				properties: data.properties
			};
		},
		setPropertiesForMatchingPopupMatchCustomer(state, data) {
			state.propertiesForMatchingPopupMatchCustomer = {
				next: data.next,
				current_page: data.current_page,
				properties: data.scroll ? [...state.propertiesForMatchingPopupMatchCustomer.properties, ...data.properties] : data.properties,
				last_page: data.last_page
			};
		},
		setCustomerInfo(state, data) {
			state.customerInfo = data;
		},
		getCustomerAssigned(state, data) {
			state.getCustomerAssigned = {
				next: data.results
			};
		}
	},
	getters: {
		getCountLeadProperty(state) {
			return state.countLeadProperty;
		},
		getTotalSelectedInStage(state) {
			return state.totalSelectedInStage;
		},
		getAgentCustomerInfinitResult(state) {
			return state.agentCustomersTotal;
		},
		getLeadsCount(state) {
			return state.leadsCount;
		},
		getLeadsPagination(state) {
			return state.leadsPagination;
		},
		getStagesPagination(state) {
			return state.stagesPagination;
		},
		getCustomerInfinitResult(state) {
			return state.customersTotal;
		},
		getAgentArchivedCustomerInfinitResult(state) {
			return state.agentArchivedTotal;
		},
		getArchivedCustomerInfinitResult(state) {
			return state.archivedTotal;
		},
		getDeletedCustomerInfinitResult(state) {
			return state.deletedCustomersTotal;
		},
		getCurrentSelected(state) {
			return state.currentSelected;
		},
		getCustomPropertiesChangeStage(state) {
			return state.customPropertiesChangeStage;
		},
		getCustomers(state) {
			return state.customers;
		},
		getAgentCustomers(state) {
			return state.agentCustomers;
		},
		getArchivedCustomers(state) {
			return state.archivedCustomers;
		},
		getDeletedCustomers(state) {
			return state.deletedCustomers;
		},
		getAgentArchivedCustomers(state) {
			return state.agentArchivedCustomers;
		},
		getMatchesCustomers(state) {
			return state.matches;
		},
		getDataCustomers(state) {
			return state.data;
		},
		getFiltersCustomers(state) {
			return state.filtersCustomer;
		},
		getPropertiesForMatching(state) {
			return state.propertiesForMatching;
		},
		getPropertiesForMatchingPopupMatchCustomer(state) {
			return state.propertiesForMatchingPopupMatchCustomer;
		},
		getCustomerInfo(state) {
			return state.customerInfo;
		},
		getCustomersTotals(state) {
			return state.totals;
		},
		getLeadDashboardCustomers(state) {
			return state.leadDashboardCustomers;
		},
		getLeadDashboardProperties(state) {
			return state.leadDashboardProperties;
		},
		getLeadDashboardCounters(state) {
			return state.leadDashboardCounters;
		}
	}
};
